import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { FieldsetBox, LegendStyled } from '../styling/StyledComponents';
import dayjs from 'dayjs';

export default function YearFilter(props) {
  const { userParams, setUserParams, selectOptions, handleChange } = props;
  var syrChoice, eyrChoice;

  const handlePorClick = (event) => {
    const syear = userParams.stnName.slice(-12,-8);
    const eyear = userParams.stnName.slice(-5,-1);
    setUserParams({ ...userParams, fromFilterYear: syear, toFilterYear: eyear })
  }

  // build year selection menu
  const yearChoices = [];
  if (userParams.hasOwnProperty('stnName') && userParams.stnName.length > 0 && userParams.stnName !== "Unknown id") {
    // use station period of record
    syrChoice = userParams.stnName.slice(-12,-8);
    eyrChoice = userParams.stnName.slice(-5,-1);
  } else {
    syrChoice = 1940;
    eyrChoice = dayjs().year();
  }
  for (let yr = syrChoice; yr <= eyrChoice; yr++) {
    yearChoices.push({value: yr, label: yr});
  }

  return (
    <Stack direction="row" alignItems="baseline" spacing={1} sx={{ mt: 2 }}>
      <FieldsetBox component="fieldset" sx={{ mr: 2, mt:1, height: 74 }}>
          <LegendStyled>Year range</LegendStyled>
          <Stack direction="row" spacing={0}>
          <TextField sx={{ m:0 }}
              select
              name="fromFilterYear"
              value={userParams.fromFilterYear}
              onChange={(e) => handleChange(e,'integer')}
          >
              {selectOptions(yearChoices)}
          </TextField>
          <Typography variant="body2" sx={{ m: 1 }}>
              through
          </Typography>
          <TextField sx={{ m:0 }}
              select
              name="toFilterYear"
              value={userParams.toFilterYear}
              onChange={(e) => handleChange(e,'integer')}
          >
              {selectOptions(yearChoices)}
          </TextField>
          </Stack>
      </FieldsetBox>
      {(userParams.hasOwnProperty('stnName') && userParams.stnName.length > 0 && userParams.stnName !== "Unknown id") &&
        <Button 
          sx={{ height: "40px" }}
          variant="light"
          onClick={handlePorClick}
        >
          Set to period of record
        </Button>
      }
    </Stack>
  )
}
